import { getHistory } from "../services/apiHistory";
import {
  getWorklog,
  getWorklogBoard,
  getWorklogDetail,
} from "../services/apiWorklog";
import { useMappedQuery } from "./queryUtils";

export function useWorklog(id) {
  return useMappedQuery({
    queryKey: ["worklog", id],
    queryFn: () => getWorklog(id),
    dataKey: "worklog",
  });
}

export function useHistory(id) {
  return useMappedQuery({
    queryKey: ["history", id],
    queryFn: () => getHistory(id),
    dataKey: "history",
  });
}

export function useWorklogDetail(id) {
  return useMappedQuery({
    queryKey: ["worklogDetail", id],
    queryFn: () => getWorklogDetail(id),
    dataKey: "worklogDetail",
  });
}

export function useWorklogBoard(id, milestoneId) {
  return useMappedQuery({
    queryKey: ["worklogBoard", id, milestoneId],
    queryFn: () => getWorklogBoard(id, milestoneId),
    dataKey: "worklogBoard",
  });
}
